const DIV_MIN = 7;
const DIV_MAX = 23;
const PRIMES = [7, 11, 13, 17, 19, 23];

const clampDiv = (n) => Math.max(DIV_MIN, Math.min(DIV_MAX, Math.round(n)));
const isPrime = (n) => PRIMES.includes(n);
const avg = (xs) => xs.reduce((a, b) => a + b, 0) / (xs.length || 1);

const nearestPrime = (n) =>
  PRIMES.reduce((best, p) => (Math.abs(p - n) < Math.abs(best - n) ? p : best), PRIMES[0]);

// State per agent: { division, phase, hue, intensity, tick, justFired }
// Personalities decide the NEXT division (rhythm choice). Phase + intensity
// are advanced uniformly by the grid each tick.
export const PERSONALITIES = {
  // sticks to primes — coprime by construction, never syncs
  prime: (self) => ({
    division: isPrime(self.division)
      ? self.division
      : nearestPrime(self.division),
    hue: 220,
  }),

  // drifts toward neighbor average — wants to sync
  consonant: (self, neighbors) => {
    if (!neighbors.length) return { division: self.division, hue: 210 };
    const m = avg(neighbors.map((n) => n.division));
    const step = Math.sign(m - self.division);
    return { division: clampDiv(self.division + step), hue: 205 };
  },

  // moves AWAY from the neighbor mode — wants to be different
  dissonant: (self, neighbors) => {
    if (!neighbors.length) return { division: self.division, hue: 235 };
    const m = avg(neighbors.map((n) => n.division));
    const step = self.division >= m ? 1 : -1;
    let d = clampDiv(self.division + step);
    if (neighbors.some((n) => n.division === d)) d = clampDiv(d + step);
    return { division: d, hue: 240 };
  },

  // doubles/halves periodically — likes 2:1 nesting
  doubler: (self) => {
    if (self.tick % 16 !== 0) return { division: self.division, hue: 215 };
    const candidates = [self.division * 2, Math.round(self.division / 2)];
    const choice = candidates[Math.floor(Math.random() * 2)];
    return { division: clampDiv(choice), hue: 215 };
  },

  // slow upward drift; wraps at DIV_MAX
  drifter: (self) => {
    if (self.tick % 24 !== 0) return { division: self.division, hue: 225 };
    const next = self.division + 1;
    return { division: next > DIV_MAX ? DIV_MIN : next, hue: 225 };
  },

  // stays put, dead simple anchor
  anchor: (self) => ({ division: self.division || 12, hue: 200 }),
};

export const PERSONALITY_NAMES = Object.keys(PERSONALITIES);

export const DEFAULT_DIVISIONS = [11, 12, 13, 14, 15, 16, 17, 18, 19];

export const initialDivision = (i) =>
  DEFAULT_DIVISIONS[i % DEFAULT_DIVISIONS.length];
